// Import model
import { PostalCodeFieldOptions } from '../models/PostalCodeFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for PostalCodeFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class PostalCodeFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a PostalCodeFieldOptions instance
   */
  static deserialize(json: string): PostalCodeFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a PostalCodeFieldOptions instance
   */
  static fromObject(obj: any): PostalCodeFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to PostalCodeFieldOptions');
    }


    const instance: PostalCodeFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      eecb9A7F: obj['_eecb9a7f'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of PostalCodeFieldOptions instances
   */
  static deserializeArray(json: string): PostalCodeFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a PostalCodeFieldOptions instance to a JSON string
   */
  static serialize(instance: PostalCodeFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a PostalCodeFieldOptions instance to a plain object
   */
  static toObject(instance: PostalCodeFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      '_eecb9a7f': instance.eecb9A7F,
    };
  }

  /**
   * Serializes an array of PostalCodeFieldOptions instances to a JSON string
   */
  static serializeArray(instances: PostalCodeFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
